import gql from 'graphql-tag'

export const SUBSCRIBE_ALL_SCHEMES1 = gql`
subscription($orgId:uuid!,$endTime:date!,$startTime:date!){
  Scheme(where: {isArchieved: {_eq: false},isSpecialScheme:{_eq: false},endTime:{_gte:$endTime},startTime:{_lte:$startTime}}){
      id
      name
      description
      backgroundImage
      schemeProductPoints {
       Product {        name      }
       points
       quantity
      }
      SchemeEnrollments(where: {partnerId: {_eq: $orgId}}){
        id earnPoint eligiblePoint myTeamEarnPoint myTeamEligiblePoint schemeId isVerified
        redemPoint redemptioInProgress transferPoints  partnerId adjustment returnOrderPoint
      }
      startTime
      endTime
      tnc
      teaserImage
      schemeDocumentType
      schemeDocuments
      criteria
      pointMethod
      points
      isHerirachyScheme
      isSpecialScheme
      applicableOn
  }
}`

export const GET_PAST_SCHEMES = gql`
query Past_Schemes($endTime:date!,$orgId:uuid!){
Past_Schemes:Scheme(where:{endTime:{_lt:$endTime},isSpecialScheme:{_eq: false},isArchieved: {_eq: false}}){
      id
      name
      description
      backgroundImage
      schemeProductPoints {
       Product {        name      }
       points
       quantity
      }
      SchemeEnrollments(where: {partnerId: {_eq: $orgId}}){
        id earnPoint eligiblePoint myTeamEarnPoint myTeamEligiblePoint schemeId
        redemPoint redemptioInProgress transferPoints  partnerId adjustment returnOrderPoint
      }
      startTime
      endTime
      tnc
      teaserImage
      schemeDocumentType
      schemeDocuments
      criteria
      pointMethod
      points
      isSpecialScheme
      isHerirachyScheme
  }
}
`
export const GET_UPCOMING_SCHEMES = gql`
query Upcoming_Schemes($startTime:date!){
Upcoming_Schemes:Scheme(where:{startTime:{_gt:$startTime},isSpecialScheme:{_eq: false},isArchieved: {_eq: false}}){
      id
      name
      description
      backgroundImage
      schemeProductPoints {
       Product {        name      }
       points
       quantity
      }
      startTime
      endTime
      tnc
      teaserImage
      schemeDocumentType
      schemeDocuments
      criteria
      pointMethod
      points
      isSpecialScheme
  }
}
`
export const GET_SCHEME_POINTS_DETAILS = gql`
query SchemePointHistory($schemeId:uuid!,$partnerId:uuid!){
  SchemePoints:SchemePointHistory(where: {schemeId: {_eq: $schemeId},partnerId:{_eq:$partnerId}},order_by: {month: asc}) {
    id
    month
    isEligible
    eligiblePoint
    earnPoint
    myTeamEarnPoint
    myTeamEligiblePoint
    isEligible
    schemeId
    adjustment
  }
}`
